jQuery('.responsive').bgResponsiveImage();
jQuery('.burger').menu();
jQuery('.preload-video').preloadVideo();
jQuery('.track-lead').fbqTrack();